import { userPreferencesRepository } from '@/adapters/database/userPreferencesRepository';
import { sentryLogger } from '@/adapters/logger/sentryLogger';
import { firebaseMessagingAdapter } from '@/adapters/pushNotification';
import { createNotificationPromptStore } from '@/stores/createNotificationPromptStore';

const useNotificationPromptStore = createNotificationPromptStore({
  pushNotification: firebaseMessagingAdapter,
  userPreferences: userPreferencesRepository,
  logger: sentryLogger,
});

export { useNotificationPromptStore };
